<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">Matriz de acceso</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap filtrosTable align-items-center" autocomplete="off">
        <div [formGroup]="formCombo" class="d-flex flex-wrap" autocomplete="off">
            <div class="p-1">
                <mat-form-field appearance="fill" class="d-block">
                    <mat-label>Rol (*)</mat-label>
                    <mat-select formControlName="idRol">
                        <mat-option [value]="item.id" *ngFor="let item of this.listaRoles">{{item.rol}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>
    <div class="mat-elevation-z8 p-0" *ngIf="!this.mostrarCargando && this.formCombo.get('idRol').value > 0">
        <div class="table-responsive">
            <table mat-table [dataSource]="dataSource" matSort class="table table-striped table-hover">

                <!-- menu Column -->
                <ng-container matColumnDef="menu">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> </th>
                    <td mat-cell *matCellDef="let row">
                        <span [class]="ObtenerClaseNivel(row.nivel)">{{row.menu}}</span>
                    </td>
                </ng-container>
                <!-- columnas -->
                <ng-container matColumnDef="lectura">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="textocentradoagrupado"> lectura</th>
                    <td mat-cell *matCellDef="let row" class="textocentradoagrupado">
                        <mat-checkbox [(ngModel)]="row.lectura" [disabled]="!row.editando">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <!-- columnas -->
                <ng-container matColumnDef="escritura">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="textocentradoagrupado"> escritura</th>
                    <td mat-cell *matCellDef="let row" class="textocentradoagrupado">
                        <mat-checkbox [(ngModel)]="row.escritura" [disabled]="!row.editando">
                        </mat-checkbox>
                    </td>
                </ng-container>
                <!-- acciones Column -->
                <ng-container matColumnDef="acciones">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
                    <td mat-cell *matCellDef="let row">
                        <a type="button" class="icnTable" (click)="Editar(row)" *ngIf="!row.editando && !this.editandoRegistro">
                            <mat-icon>edit</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="Guardar(row)" *ngIf="row.editando">
                            <mat-icon>save</mat-icon>
                        </a>
                        <a type="button" class="icnTable" (click)="CancelarEditar(row)" *ngIf="row.editando">
                            <mat-icon>close</mat-icon>
                        </a>
                    </td>
                </ng-container>

                <!-- encabezados agrupados -->
                <ng-container [matColumnDef]="item" *ngFor="let item of columnasEncabezadoAgrupado">
                    <th mat-header-cell *matHeaderCellDef [class]="item === 'Modulo' ? 'textocentradoagrupado' : 'textocentradosecundario'" [attr.colspan]="item === 'Modulo' ? 1 : 2">
                        {{item}}
                    </th>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnasEncabezadoAgrupado"></tr>
                <tr mat-header-row *matHeaderRowDef="columnasEncabezado"></tr>
                <tr mat-row *matRowDef="let row; columns: columnasEncabezado;"></tr>

                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                </tr>
            </table>
        </div>
    </div>
    <div class="fondopaginador">
        <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
    </div>
</div>